import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useEvieChatContext } from '../EvieChatProvider';
import { useCreateChatMessage } from '../hooks';

import './quick-replies.scss';

const QuickReplies = ({ items, updateUserMessage }) => {
  const { t } = useTranslation();
  const { isQuotaExceeded } = useEvieChatContext();
  const { sendMessage } = useCreateChatMessage({ updateUserMessage });

  return (
    <li className="messages__msg quick-replies-wrapper">
      <div className="quick-replies">
        <p className="quick-replies__label">{t('evieApp.assistant.quickReplies.label')}</p>
        <div className="quick-replies__grid">
          {items.map((item) => {
            const text = typeof item === 'string' ? item : item.text;
            const isFullWidth = text.length > 35;

            return (
              <button
                key={text}
                type="button"
                className={`quick-replies__chip ${isFullWidth ? 'chip-full' : ''}`}
                disabled={isQuotaExceeded}
                onClick={(event) => sendMessage(event, text)}
              >
                {text}
              </button>
            );
          })}
        </div>
      </div>
    </li>
  );
};

QuickReplies.propTypes = {
  items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ text: PropTypes.string })]))
    .isRequired,
  updateUserMessage: PropTypes.func.isRequired,
};

export default QuickReplies;
